<div class="card mt-4 mb-4 mb-xxl-10">
    <div class="card-header">
        <div class="card-title">
            <h3>{{ isCreateComapny() ? 'Add New Company' : companyTitle() }}</h3>
        </div>
    </div>
    <div class="card-body px-0 py-0">
        <mat-tab-group [selectedIndex]="selectedTab()" (selectedIndexChange)="onTabChange($event)">
            <mat-tab>
                <ng-template mat-tab-label> 
                    <h3 class="fw-bold text-gray-900 mb-0">Company Details</h3>
                </ng-template>
                @if (selectedTab() === 0) {
                    <app-company-details
                        [companyDetailForm]="companyForm"
                        [companyId]="companyId()"
                        (countryChange)="onCountryChange($event)"
                        [formatPhoneNumber]="formatPhoneNumber.bind(this)"
                        [extractRawPhoneNumber]="extractRawPhoneNumber.bind(this)">
                    </app-company-details>
                }
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label> 
                    <h3 class="fw-bold text-gray-900 mb-0">Contact Person Details</h3>
                </ng-template>
                @if (selectedTab() === 1) {
                    <app-contact-details
                        [companyDetailForm]="companyForm"
                        [formatPhoneNumber]="formatPhoneNumber.bind(this)"
                        [extractRawPhoneNumber]="extractRawPhoneNumber.bind(this)">
                    </app-contact-details>
                }
            </mat-tab>
            @if (hasSurplusTab()) {
                <mat-tab>
                    <ng-template mat-tab-label> 
                        <h3 class="fw-bold text-gray-900 mb-0">Surplus Lines - License Details</h3>
                    </ng-template>
                    @if (selectedTab() === 2) {
                        <app-surplus-lines-license-details
                            [companyDetailForm]="companyForm"
                            [companyId]="companyId()"
                            [isCreateCompany]="isCreateComapny()">
                        </app-surplus-lines-license-details>
                    }
                </mat-tab>
            }
        </mat-tab-group>
        <mat-action-row class="accordion-footer d-flex justify-content-end py-5 px-6">
            @if (selectedTab() === 0) {
                <button mat-button type="button" (click)="onCancel()" class="btn btn-lg btn-light-primary me-3 back-btn">Cancel</button>
                <div [attr.title]="!isCompanyDetailsFieldsValid() ? 'Please fix the errors in the form.' : null">
                    <button mat-button type="button" (click)="onNext()" class="btn btn-lg btn-primary continue-btn">Next</button>
                </div>
            } @else if (selectedTab() === 1 && hasSurplusTab()) {
                <button mat-button type="button" (click)="onCancel()" class="btn btn-lg btn-light-primary me-3 back-btn">Cancel</button>
                <button mat-button type="button" (click)="onPrevious()" class="btn btn-lg btn-light-primary me-3 back-btn">Previous</button>
                <div [attr.title]="!isContactDetailsFieldsVaild() ? 'Please fix the errors in the form.' : null">
                    <button mat-button type="button" (click)="onNext()" class="btn btn-lg btn-primary continue-btn">Next</button>
                </div>
            } @else {
                <button mat-button type="button" (click)="onCancel()" class="btn btn-lg btn-light-primary me-3 back-btn">Cancel</button>
                <button mat-button type="button" (click)="onPrevious()" class="btn btn-lg btn-light-primary me-3 back-btn">Previous</button>
                <div [attr.title]="companyForm.invalid || isSlaGridRequiredAndEmpty() ? 'Please fix the errors in the form.' : null">
                    <button
                      mat-button
                      type="button"
                      (click)="onSubmit()"
                      [disabled]="this.companyForm.invalid || isSlaGridRequiredAndEmpty()"
                      class="btn btn-lg btn-primary continue-btn"
                    >
                      {{ isCreateComapny() ? 'Create' : 'Save' }}
                    </button>
                </div>
            }
        </mat-action-row> 
    </div>
</div>
